module.exports = __webpack_public_path__ + "img/massage.e5fa5349.svg";